import { useContext } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
export default function UI_LinearGroup({
    id,
    Direction = "Row",
    Gap = true,
    Title,
    Fill,
    Wrap,
    children
}) {
    const UI = useContext(Context_UI);

    return (
        <>
            {Title != null ? 
                <p className="LinearGroup_Title">
                    {Title}
                </p>
                :
                ""
            }
            
            <div
                className="LinearGroup"
                Direction={Direction == "Column" ? "Column" : "Row"}
                Gap={Gap == true ? "Gap" : "None"}
                Fill={Fill ? "Fill" : ""}
                Wrap={Wrap ? "Wrap" : "NoWrap"}
            >
                {children}
            </div>
        </>
    )
}

